<div class="alerts-component">
    <div class="map-container left-div card">
        <app-alerts-map
            #mapControl
            [center]="center"
            [alerts]="getAlerts()"
            (authCenterChanged)="authCenterChanged($event)"
        ></app-alerts-map>
    </div>

    <div class="selected-alert right-div">
        <app-selected-alert
            [selectedAlert]="selectedAlert"
        ></app-selected-alert>
    </div>
</div>
